import { Reveal } from "./Reveal";

// Material/detail system — activated from Phase 2. Slots filled with real
// fabric/stitch/label photography during the reveal phases.
const SLOTS = [
  { id: "fabric", label: "Fabric", note: "450gsm heavyweight cotton" },
  { id: "stitch", label: "Construction", note: "Reinforced seams · oversized cut" },
  { id: "print", label: "Print", note: "Screen + puff · translated from paper" },
  { id: "label", label: "Credential", note: "Numbered · recorded · archived" },
];

export const MaterialSystem = ({ images = {} }) => (
  <section id="material" data-testid="material-system" className="relative py-28 md:py-44 border-t border-bds-border">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <Reveal>
        <span className="font-mono-bds text-xs uppercase tracking-[0.3em] text-bds-accent">Material</span>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-serif-display font-light text-5xl md:text-7xl tracking-tighter leading-[0.9] mt-6 mb-16 md:mb-24">
          Built to be <span className="italic text-bds-muted">felt.</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        {SLOTS.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.06}>
            <figure data-testid={`material-slot-${s.id}`}>
              <div className="aspect-square bg-[#0C0C0F] overflow-hidden grid place-items-center">
                {images[s.id] ? (
                  <img src={images[s.id]} alt={`${s.label} detail — Black Dog Society`} loading="lazy" className="w-full h-full object-cover grayscale" />
                ) : (
                  <span className="font-mono-bds text-[10px] uppercase tracking-[0.3em] text-bds-muted/50">Sealed</span>
                )}
              </div>
              <figcaption className="mt-4">
                <p className="font-serif-display text-xl">{s.label}</p>
                <p className="font-mono-bds text-[10px] uppercase tracking-[0.2em] text-bds-muted mt-1">{s.note}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
